
import { defineComponent } from "vue";
import BaseSpinner from "~/components/base/BaseSpinner.vue";

export default defineComponent({
	components: {
		BaseSpinner,
	},
	props: {
		loading: {
			type: Boolean,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
		},
	},
	setup() {
		return {};
	},
});
